import {Component, OnDestroy, OnInit} from '@angular/core'
import {
    ConfigSettingsType,
    PatientDefaultPage,
    Practice,
    PracticeSettings,

    Units,
} from '../../../api/models'
import {
    PracticeSettingsFormControls,
    practiceSettingsFormControls,
} from '../../../forms/PracticeSettingsFormControls'
import {
    FormBuilder,
    FormControl,
    FormGroup,
    UntypedFormControl,
    UntypedFormGroup,
    Validators,
} from '@angular/forms'
import { ConfigSettingService } from '../../../api/services/config-setting.service'
import { UserPracticesService } from '../../../api/services/user-practices.service'
import {Observable, of, startWith, Subject, switchMap, takeUntil} from 'rxjs'
import { MessageService } from 'primeng/api'
import { environment } from '../../../../environments/environment'
import { DocumentService } from '../../../api/services'
import { CareFinitySession } from '../../services/CareFinitySession'


enum StorageType {
    "Local Storage" = 0,
    "Input S3 Storage" = 1,

}


enum StorageTypeOutput {
    "Local Storage" = 0,
    "Output S3 Storage" = 1,

}

enum PatientImageViewType {
    "Thumbnail View" = 0,
    "List View" = 1
}


@Component({
    selector: 'app-practice-settings',
    templateUrl: './practice-settings.component.html',
    styleUrl: './practice-settings.component.css',
})
export class PracticeSettingsComponent implements OnInit,OnDestroy {
    frmPracticeSettings: UntypedFormGroup
    practice = new FormControl<string>('')

    practices: Observable<Array<Practice>> = of([])
    isEdit: boolean = false

    // settings$: Observable<JsonSettings> = of({});
    settingTypes: Array<{ label: string; value: string }> = []
    selectedSetting = new FormControl<string>('')
    form: FormGroup<any>
    model = {}
    initialFormValues: any = {};

    practiceId = ''

    speakText = 'help'

    chartUnitOptions: { key: number; value: string }[];

    patientDefaultPageOptions: { key: number; value: string }[];
    inputStorageTypeOptions: { key: number; value: string }[];
    outputStorageTypeOptions: { key: number; value: string }[];
    notesStorageTypeOptions: { key: number; value: string }[];

    patientImageViewTypeOptions: { key: number; value: string }[];


    referringOptions = [
        { key: 'P', value: 'Provider' },
        { key: 'R', value: 'Resource' },
    ]
    headerBlankOptions = [
        { key: 'A', value: 'AppendRTF To PreviousRTF' },
        { key: 'S', value: 'SkipRTF' },
    ]
    skipHeaderIfRTFBlankOptions = [
        { key: 'YES', value: 'YES' },
        { key: 'NO', value: 'NO' },
    ]

    rtfOrientationOptions = [
        { key: 'Landscape', value: 'Landscape' },
        { key: 'Portrait', value: 'Portrait' },
    ]

    isDisabled_NotesWaterMark = false
    isDisabled_PdfWaterMark = false

    isDisabled_RtfConversion = false

    isDisabled_EnableBilling = false

    isDispalyBilling: boolean = true

    isDisabled_RtfSingle: boolean = true;
    isInputStoreType_local: boolean = true;
    isInputStoreType_s3: boolean = true;
    isOutputStoreType_local: boolean = true;
    isOutputStoreType_s3: boolean = true;

    showPracticeMessage: boolean = false;
    practiceMessage: string = "Nice! 🎉 Practice settings have loaded successfully from XML file.";

    isImportSettingVisiable: boolean = false;
    isDisabled: boolean = true;

    isSaving: boolean = false;
    isGlobalAdmin = CareFinitySession.user.roles.globalAdminPrivilege;
    isNotesStoreType_local: boolean
    isNotesStoreType_s3: boolean

    private destroyed=new Subject<void>();
    constructor(
        private fb: FormBuilder,
        private configSettingService: ConfigSettingService,
        private userPracticeService: UserPracticesService,
        private messageService: MessageService,
        private documentService: DocumentService
    ) { }

    ngOnDestroy(): void {

this.destroyed.next();
    }

    ngOnInit() {


        this.chartUnitOptions = this.getEnumOptions(Units);

        this.patientDefaultPageOptions = this.getEnumOptions(PatientDefaultPage);

        this.inputStorageTypeOptions = this.getEnumOptions(StorageType);
        this.outputStorageTypeOptions = this.getEnumOptions(StorageTypeOutput);
        this.notesStorageTypeOptions = [{ "value": "Input Storage Type", "key": 0 }, { "value": "Output Storage Type", "key": 1 }]

        this.patientImageViewTypeOptions = this.getEnumOptions(PatientImageViewType);

        this.frmPracticeSettings = new UntypedFormGroup({
            billingXMLDataPath: new UntypedFormControl(
                { value: null, disabled: true },
                [],
            ),
            browserPDFViewer: new UntypedFormControl(false, []), //[false],
            chartUnit: new UntypedFormControl(Units.English, []), //[''],
            convertFolderPath: new UntypedFormControl(null, []), //[null],
            defaultAppointmentType: new UntypedFormControl(null, []), //[null],
            disableEmbeddedPDFFonts: new UntypedFormControl(false, []), // [false],
            displayHTMLForDocX: new UntypedFormControl(false, []), //[false],
            displayHTMLView: new UntypedFormControl(false, []), //[false],
            documentFolderPath: new UntypedFormControl(null, []), // [null],
            enableBilling: new UntypedFormControl(false, []), //[false],
            enableFinancialSummary: new UntypedFormControl(false, []), // [false],
            enablePatientHeader: new UntypedFormControl(false, []), //[false],
            //  enablePrintDocuments: new UntypedFormControl(false, []), // [false],
            // enablePrintExportDocs: new UntypedFormControl(false, []), // [false],
            //  enablePrintImages: new UntypedFormControl(false, []), //[false],
            // enablePrintReports: new UntypedFormControl(false, []), //[false],
            exportDocumentFolder: new UntypedFormControl(null, []), // [null],
            icsFolderPath: new UntypedFormControl(null, []), //[null],
            imageFolderPath: new UntypedFormControl(null, []), //[null],
            inpatientFilePath: new UntypedFormControl(
                { value: null, disabled: true },
                [],
            ),
            inpatientLabelText: new UntypedFormControl(
                { value: null, disabled: true },
                [],
            ),
            isArchiveInstance: new UntypedFormControl(false, []), //[false],
            isImageZipped: new UntypedFormControl(false, []), // [false],
            leadConvertAppPath: new UntypedFormControl(null, []), // [null],
            notesFolder: new UntypedFormControl(null, [Validators.required]), // [null],
            notesTemplatePath: new UntypedFormControl(null, []), //[null],
            notesWaterMarkSettings: new UntypedFormGroup({
                addDOB: new UntypedFormControl({ value: false, disabled: true }, []),
                addDescription: new UntypedFormControl(
                    { value: false, disabled: true },
                    [],
                ),
                addGender: new UntypedFormControl({ value: false, disabled: true }, []),
                addLocation: new UntypedFormControl(
                    { value: false, disabled: true },
                    [],
                ),
                addMRN: new UntypedFormControl({ value: false, disabled: true }, []),
                addPatientName: new UntypedFormControl(
                    { value: false, disabled: true },
                    [],
                ), //[false],
                addSSN: new UntypedFormControl({ value: false, disabled: true }, []), //[false],
                addVisitDate: new UntypedFormControl(
                    { value: false, disabled: true },
                    [],
                ),
                enabled: new UntypedFormControl({ value: false }, []),
                locationLabel: new UntypedFormControl(
                    { value: null, disabled: true },
                    [],
                ),
                locationX: new UntypedFormControl({ value: null, disabled: true }, []),
                locationY: new UntypedFormControl({ value: null, disabled: true }, []),
                mrnLabel: new UntypedFormControl({ value: null, disabled: true }, []),
            }),
            officeFilePath: new UntypedFormControl(
                { value: null, disabled: true },
                [],
            ),
            officeLabelText: new UntypedFormControl(
                { value: null, disabled: true },
                [],
            ),
            outpatientFilePath: new UntypedFormControl(
                { value: null, disabled: true },
                [],
            ),
            outpatientLabelText: new UntypedFormControl(
                { value: null, disabled: true },
                [],
            ),
            outputFolderPath: new UntypedFormControl({ value: null }, []),
            paqProviderType: new UntypedFormControl(null, []), //[null],
            pdfWaterMarkSettings: new UntypedFormGroup({
                addDOB: new UntypedFormControl({ value: false, disabled: true }, []),
                addDescription: new UntypedFormControl(
                    { value: false, disabled: true },
                    [],
                ),
                addGender: new UntypedFormControl({ value: false, disabled: true }, []),
                addLocation: new UntypedFormControl(
                    { value: false, disabled: true },
                    [],
                ),
                addMRN: new UntypedFormControl({ value: false, disabled: true }, []),
                addPatientName: new UntypedFormControl(
                    { value: false, disabled: true },
                    [],
                ), //[false],
                addSSN: new UntypedFormControl({ value: false, disabled: true }, []), //[false],
                addVisitDate: new UntypedFormControl(
                    { value: false, disabled: true },
                    [],
                ),
                enabled: new UntypedFormControl({ value: false }, []),
                locationLabel: new UntypedFormControl(
                    { value: null, disabled: true },
                    [],
                ),
                locationX: new UntypedFormControl({ value: null, disabled: true }, []),
                locationY: new UntypedFormControl({ value: null, disabled: true }, []),
                mrnLabel: new UntypedFormControl({ value: null, disabled: true }, []),
            }),
            rtfConversionSettings: new UntypedFormGroup({
                appendRTFToPreviousRTFIFHeaderBlank: new UntypedFormControl(false, []), //[false],
                forceNewLineAfterHeader: new UntypedFormControl(false, []), // [false],
                forceNewLineBeforeHeader: new UntypedFormControl(false, []), //[false],
                headerFormat: new UntypedFormGroup({
                    bold: new UntypedFormControl(false, []), // [false],
                    fontColor: new UntypedFormControl(null, []), // [null],
                    fontName: new UntypedFormControl(null, []), // [null],
                    fontSize: new UntypedFormControl(0, []), //[null],
                    underline: new UntypedFormControl(false, []), // [false]
                }),
                skipHeaderIfRTFBlank: new UntypedFormControl(false, []), // [false],
                useInteropForRTF: new UntypedFormControl(false, []), //[false]
                rtfFileName: new UntypedFormControl(null, []), //[null],
            }),

            showAppointment: new UntypedFormControl(false, []), // [false],
            showClinicalData: new UntypedFormControl(false, []), //[false],
            showExportDocuments: new UntypedFormControl(false, []), // [false],
            showFinancialData: new UntypedFormControl(false, []), //[false],
            showPatientArchive: new UntypedFormControl(false, []), // [false],
            showPatientImage: new UntypedFormControl(false, []), //[false],
            showPatientNotes: new UntypedFormControl(false, []), // [false],
            showPracticeMessagePopUp: new UntypedFormControl(false, []), //[false],
            showRestoreTabToUser: new UntypedFormControl(false, []), // [false],
             enableDocumentDownloads: new UntypedFormControl(false, []), // [false],
            showSignOffQueue: new UntypedFormControl(false, []), // [false],
            showTasks: new UntypedFormControl(false, []), // [false],
            xsltFilePath: new UntypedFormControl(null, []), // [null]
            //  enablePrintAppointments: new UntypedFormControl(null, []),

            inpatientColSpan: new UntypedFormControl(
                { value: null, disabled: true },
                [],
            ),
            outPatientColSpan: new UntypedFormControl(
                { value: null, disabled: true },
                [],
            ),
            officeColSpan: new UntypedFormControl(
                { value: null, disabled: true },
                [],
            ),
            ageinYearsMonthsDays: new UntypedFormControl(0, []),
            ageinYearsMonths: new UntypedFormControl(null, []),

            showPatientDocuments: new UntypedFormControl(false, []),

            showExportCCDA: new UntypedFormControl(false, []),
            singleRTFSetting: new UntypedFormGroup({
                margins: new UntypedFormControl(false, []), // [false],
                leftMargin: new UntypedFormControl({ value: null, disabled: true }, []), //new UntypedFormControl(0, []), //[null],
                rightMargin: new UntypedFormControl(
                    { value: null, disabled: true },
                    [],
                ), //new UntypedFormControl(0, []), // [null],
                topMargin: new UntypedFormControl({ value: null, disabled: true }, []), //new UntypedFormControl(0, []), // [null],
                bottomMargin: new UntypedFormControl(
                    { value: null, disabled: true },
                    [],
                ), //new UntypedFormControl(0, []), //[null],
                orientation: new UntypedFormControl(null, []), //[null],
            }),
            enablePatientDemographicPrint: new UntypedFormControl(false, []),
            isEmptyInputFromTemplate: new UntypedFormControl(false, []),

            viewEOBImage: new UntypedFormControl(false, []),
            viewInsuranceCard: new UntypedFormControl(false, []),
            patientDefaultPage: new UntypedFormControl(PatientDefaultPage.Dashboard, []), //[''],

            isSignificantEvent: new UntypedFormControl(false, []),
            //Input Storage Type:: S3
            inputStorageType: new UntypedFormControl(StorageType['Local Storage'], [Validators.required]),
            imageStorageType: new UntypedFormControl(StorageType['Local Storage'], [Validators.required]),
            inputS3AccessKey: new UntypedFormControl(null, [Validators.required]),
            inputS3Region: new UntypedFormControl(null, [Validators.required]),
            inputS3SecretKey: new UntypedFormControl(null, [Validators.required]),
            inputAwsBucket: new UntypedFormControl(null, [Validators.required]),

            notesStorageType: new UntypedFormControl('Output Storage Type', [Validators.required]),
            //Output Storage Type:: S3
            outputStorageType: new UntypedFormControl(StorageType['Local Storage'], [Validators.required]),
            outputS3AccessKey: new UntypedFormControl(null, [Validators.required]),
            outputS3Region: new UntypedFormControl(null, [Validators.required]),
            outputS3SecretKey: new UntypedFormControl(null, [Validators.required]),
            outputAwsBucket: new UntypedFormControl(null, [Validators.required]),


            patientImageViewType: new UntypedFormControl(PatientImageViewType['Thumbnail View'], []),
            showPatientDemographics: new UntypedFormControl(false, []), //[false],
            showPatientPayer: new UntypedFormControl(false, []), //[false],
            enableInputS3 :new FormControl(false),
            enableOutputS3: new FormControl(false)

        });



        this.frmPracticeSettings.get('enableInputS3').valueChanges.pipe(startWith(CareFinitySession.practiceSettings.enableInputS3),takeUntil(this.destroyed)).subscribe(res => {

            const s3Controls = ['inputS3AccessKey', 'inputS3Region', 'inputS3SecretKey', 'inputAwsBucket'];




            s3Controls.forEach(control=> {

                if(!res) {
                    this.frmPracticeSettings.get(control).disable();
                    this.inputStorageTypeOptions=this.inputStorageTypeOptions.filter(i=> i.key!==StorageType["Input S3 Storage"].valueOf())
                }
                else {
                    this.frmPracticeSettings.get(control).enable();
                   this.inputStorageTypeOptions= this.getEnumOptions(StorageType);

                }

            })




        })

        this.frmPracticeSettings.get('enableOutputS3').valueChanges.pipe(startWith(CareFinitySession.practiceSettings.enableOutputS3),takeUntil(this.destroyed)).subscribe(res => {

            const s3Controls = ['outputS3AccessKey', 'outputS3Region', 'outputS3SecretKey', 'outputAwsBucket'];


        

            s3Controls.forEach(control=> {


                if(!res) {
                    this.frmPracticeSettings.get(control).disable();
                    this.outputStorageTypeOptions = this.outputStorageTypeOptions.filter(i => i.key !== StorageTypeOutput["Output S3 Storage"].valueOf())


                }
                else {
                    this.frmPracticeSettings.get(control).enable();
                    this.outputStorageTypeOptions = this.getEnumOptions(StorageTypeOutput);

                }


            })





        })

        if (CareFinitySession.user.roles.globalAdminPrivilege) {

            this.frmPracticeSettings.addControl('showSensitiveData',new FormControl())
        }
        this.isImportSettingVisiable = localStorage.getItem('isImportSettings') === 'true';

        this.practices =
            this.userPracticeService.userPracticesGetAllPracticesOfUser()
        this.practice.setValue(localStorage.getItem('EmrPracticeId'))
        this.practice.valueChanges
            .pipe(
                startWith(localStorage.getItem('EmrPracticeId')),
                switchMap((practice) => {
                    this.practiceId = practice
                    return this.configSettingService.configSettingGetPracticeSettings({
                        type: '1',
                        practiceId: practice,
                    })
                }),
            )
            .subscribe((res) => {
                if (res) {
                    this.isEdit = true
                    this.frmPracticeSettings.patchValue(res)
                } else {
                    this.isEdit = false
                    this.frmPracticeSettings.patchValue(res)
                }
            })

        // Subscribe to value changes for specific controls to ensure numeric values
        this.addValueChangeSubscriptions()
    }

    private getEnumOptions(enumType: any): { key: number; value: string }[] {
        return Object.keys(enumType)
            .filter((key) => !isNaN(Number(enumType[key])))
            .map((key) => ({ key: enumType[key], value: key }))
    }

    // Adding subscriptions to specific controls
    private addValueChangeSubscriptions(): void {
        this.frmPracticeSettings
            .get('chartUnit')
            ?.valueChanges.subscribe((value) => {
                this.convertToNumberIfString('chartUnit', value)
            })

        this.frmPracticeSettings
            .get('pdfWaterMarkSettings.enabled')
            ?.valueChanges.subscribe((res) => {
                this.isDisabled_PdfWaterMark = !res

                //const checkboxControl = this.frmPracticeSettings.get('pdfWaterMarkSettings.addPatientName');
                if (res) {
                    //  checkboxControl?.enable(); // Enable the checkbox

                    this.frmPracticeSettings.get('pdfWaterMarkSettings.addDOB').enable()
                    this.frmPracticeSettings
                        .get('pdfWaterMarkSettings.addDescription')
                        .enable()
                    this.frmPracticeSettings
                        .get('pdfWaterMarkSettings.addGender')
                        .enable()
                    this.frmPracticeSettings
                        .get('pdfWaterMarkSettings.addLocation')
                        .enable()
                    this.frmPracticeSettings.get('pdfWaterMarkSettings.addMRN').enable()
                    this.frmPracticeSettings
                        .get('pdfWaterMarkSettings.addPatientName')
                        .enable()
                    this.frmPracticeSettings.get('pdfWaterMarkSettings.addSSN').enable()
                    this.frmPracticeSettings
                        .get('pdfWaterMarkSettings.addVisitDate')
                        .enable()
                    this.frmPracticeSettings
                        .get('pdfWaterMarkSettings.locationLabel')
                        .enable()
                    this.frmPracticeSettings
                        .get('pdfWaterMarkSettings.locationX')
                        .enable()
                    this.frmPracticeSettings
                        .get('pdfWaterMarkSettings.locationY')
                        .enable()
                    this.frmPracticeSettings.get('pdfWaterMarkSettings.mrnLabel').enable()
                } else {
                    // checkboxControl?.disable(); // Disable the checkbox

                    this.frmPracticeSettings.get('pdfWaterMarkSettings.addDOB').disable()
                    this.frmPracticeSettings
                        .get('pdfWaterMarkSettings.addDescription')
                        .disable()
                    this.frmPracticeSettings
                        .get('pdfWaterMarkSettings.addGender')
                        .disable()
                    this.frmPracticeSettings
                        .get('pdfWaterMarkSettings.addLocation')
                        .disable()
                    this.frmPracticeSettings.get('pdfWaterMarkSettings.addMRN').disable()
                    this.frmPracticeSettings
                        .get('pdfWaterMarkSettings.addPatientName')
                        .disable()
                    this.frmPracticeSettings.get('pdfWaterMarkSettings.addSSN').disable()
                    this.frmPracticeSettings
                        .get('pdfWaterMarkSettings.addVisitDate')
                        .disable()
                    this.frmPracticeSettings
                        .get('pdfWaterMarkSettings.locationLabel')
                        .disable()
                    this.frmPracticeSettings
                        .get('pdfWaterMarkSettings.locationX')
                        .disable()
                    this.frmPracticeSettings
                        .get('pdfWaterMarkSettings.locationY')
                        .disable()
                    this.frmPracticeSettings
                        .get('pdfWaterMarkSettings.mrnLabel')
                        .disable()
                }
            })
        this.frmPracticeSettings
            .get('notesWaterMarkSettings.enabled')
            ?.valueChanges.subscribe((res) => {
                this.isDisabled_NotesWaterMark = !res

                //const checkboxControl = this.frmPracticeSettings.get('pdfWaterMarkSettings.addPatientName');
                if (res) {
                    //  checkboxControl?.enable(); // Enable the checkbox

                    this.frmPracticeSettings.get('notesWaterMarkSettings.addDOB').enable()
                    this.frmPracticeSettings
                        .get('notesWaterMarkSettings.addDescription')
                        .enable()
                    this.frmPracticeSettings
                        .get('notesWaterMarkSettings.addGender')
                        .enable()
                    this.frmPracticeSettings
                        .get('notesWaterMarkSettings.addLocation')
                        .enable()
                    this.frmPracticeSettings.get('notesWaterMarkSettings.addMRN').enable()
                    this.frmPracticeSettings
                        .get('notesWaterMarkSettings.addPatientName')
                        .enable()
                    this.frmPracticeSettings.get('notesWaterMarkSettings.addSSN').enable()
                    this.frmPracticeSettings
                        .get('notesWaterMarkSettings.addVisitDate')
                        .enable()
                    this.frmPracticeSettings
                        .get('notesWaterMarkSettings.locationLabel')
                        .enable()
                    this.frmPracticeSettings
                        .get('notesWaterMarkSettings.locationX')
                        .enable()
                    this.frmPracticeSettings
                        .get('notesWaterMarkSettings.locationY')
                        .enable()
                    this.frmPracticeSettings
                        .get('notesWaterMarkSettings.mrnLabel')
                        .enable()
                } else {
                    // checkboxControl?.disable(); // Disable the checkbox

                    this.frmPracticeSettings
                        .get('notesWaterMarkSettings.addDOB')
                        .disable()
                    this.frmPracticeSettings
                        .get('notesWaterMarkSettings.addDescription')
                        .disable()
                    this.frmPracticeSettings
                        .get('notesWaterMarkSettings.addGender')
                        .disable()
                    this.frmPracticeSettings
                        .get('notesWaterMarkSettings.addLocation')
                        .disable()
                    this.frmPracticeSettings
                        .get('notesWaterMarkSettings.addMRN')
                        .disable()
                    this.frmPracticeSettings
                        .get('notesWaterMarkSettings.addPatientName')
                        .disable()
                    this.frmPracticeSettings
                        .get('notesWaterMarkSettings.addSSN')
                        .disable()
                    this.frmPracticeSettings
                        .get('notesWaterMarkSettings.addVisitDate')
                        .disable()
                    this.frmPracticeSettings
                        .get('notesWaterMarkSettings.locationLabel')
                        .disable()
                    this.frmPracticeSettings
                        .get('notesWaterMarkSettings.locationX')
                        .disable()
                    this.frmPracticeSettings
                        .get('notesWaterMarkSettings.locationY')
                        .disable()
                    this.frmPracticeSettings
                        .get('notesWaterMarkSettings.mrnLabel')
                        .disable()
                }
            })

        this.frmPracticeSettings.get('showPatientArchive')?.valueChanges.subscribe(res => {

            // this.isDisabled_RtfConversion = !res;

            if (res) {

                this.frmPracticeSettings.get('isSignificantEvent').enable();
                this.frmPracticeSettings.get('showRestoreTabToUser').enable();


            } else {
                // checkboxControl?.disable(); // Disable the checkbox
                this.frmPracticeSettings.get('isSignificantEvent').setValue(false);
                this.frmPracticeSettings.get('showRestoreTabToUser').setValue(false);

                this.frmPracticeSettings.get('isSignificantEvent').disable();
                this.frmPracticeSettings.get('showRestoreTabToUser').disable();

            }

        });

        this.frmPracticeSettings
            .get('enableBilling')
            ?.valueChanges.subscribe((res) => {
                this.isDisabled_EnableBilling = !res

                this.isDispalyBilling = res

                if (res) {


                    this.frmPracticeSettings.get('billingXMLDataPath').value;

                    this.frmPracticeSettings.get('billingXMLDataPath').enable()
                    this.frmPracticeSettings.get('inpatientFilePath').enable()
                    this.frmPracticeSettings.get('inpatientLabelText').enable()
                    this.frmPracticeSettings.get('inpatientColSpan').enable()
                    this.frmPracticeSettings.get('outpatientLabelText').enable()
                    this.frmPracticeSettings.get('outpatientFilePath').enable()
                    this.frmPracticeSettings.get('outPatientColSpan').enable()
                    this.frmPracticeSettings.get('officeLabelText').enable()
                    this.frmPracticeSettings.get('officeFilePath').enable()
                    this.frmPracticeSettings.get('officeColSpan').enable()
                    // this.frmPracticeSettings.get('outputFolderPath').enable();
                } else {
                    // checkboxControl?.disable(); // Disable the checkbox

                    // this.frmPracticeSettings.get('outputFolderPath').disable();



                    this.frmPracticeSettings.get('billingXMLDataPath').disable()
                    this.frmPracticeSettings.get('inpatientFilePath').disable()
                    this.frmPracticeSettings.get('inpatientLabelText').disable()
                    this.frmPracticeSettings.get('inpatientColSpan').disable()
                    this.frmPracticeSettings.get('outpatientLabelText').disable()
                    this.frmPracticeSettings.get('outpatientFilePath').disable()
                    this.frmPracticeSettings.get('outPatientColSpan').disable()
                    this.frmPracticeSettings.get('officeLabelText').disable()
                    this.frmPracticeSettings.get('officeFilePath').disable()
                    this.frmPracticeSettings.get('officeColSpan').disable()
                }
            })

        this.frmPracticeSettings
            .get('singleRTFSetting.margins')
            ?.valueChanges.subscribe((res) => {
                this.isDisabled_RtfSingle = !res
                if (res) {
                    this.frmPracticeSettings.get('singleRTFSetting.bottomMargin').enable()
                    this.frmPracticeSettings.get('singleRTFSetting.leftMargin').enable()
                    this.frmPracticeSettings.get('singleRTFSetting.rightMargin').enable()
                    this.frmPracticeSettings.get('singleRTFSetting.topMargin').enable()
                    this.frmPracticeSettings.get('singleRTFSetting.orientation').enable()
                } else {
                    // checkboxControl?.disable(); // Disable the checkbox
                    this.frmPracticeSettings
                        .get('singleRTFSetting.bottomMargin')
                        .disable()
                    this.frmPracticeSettings.get('singleRTFSetting.leftMargin').disable()
                    this.frmPracticeSettings.get('singleRTFSetting.rightMargin').disable()
                    this.frmPracticeSettings.get('singleRTFSetting.topMargin').disable()
                    this.frmPracticeSettings.get('singleRTFSetting.orientation').disable()
                }
            });


     



    }

    // Convert control value to number if it's a string
    private convertToNumberIfString(controlPath: string, value: any): void {
        if (typeof value === 'string' && !isNaN(Number(value))) {
            this.frmPracticeSettings
                .get(controlPath)
                ?.setValue(Number(value), { emitEvent: false })
        }
    }

    //onSubmit() {

    //    if (this.isSaving) return;
    //    // Prevent multiple submissions
    //    this.isSaving = true;

    //    if (this.frmPracticeSettings.valid) {
    //        console.log('Form Submitted', this.frmPracticeSettings.value)
    //    }
    //    if (this.frmPracticeSettings.invalid) {
    //        console.log('Form Submitted', this.frmPracticeSettings.value);
    //        this.frmPracticeSettings.markAllAsTouched();
    //        return;
    //    }
    //    console.log('Form Submitted', this.frmPracticeSettings.value)

    //    if (!this.checkBillingSettingNames()) {
    //        this.messageService.add({
    //            key: 'alertToast',
    //            severity: 'error',
    //            detail:
    //                'Billing setting names or alias must be different: List1, List2, and List3',
    //            summary: 'ERROR',
    //            life: 7000,
    //        })
    //    } else {
    //        if (!this.isEdit) {
    //            //  alert("add");
    //            this.configSettingService
    //                .configSettingSavePracticeSettings({
    //                    type: '1',
    //                    practiceId: this.practiceId,
    //                    body: this.frmPracticeSettings.value,
    //                })
    //                .subscribe(
    //                    (result) => {
    //                        console.log(result)

    //                        this.messageService.add({
    //                            key: 'alertToast',
    //                            severity: 'success',
    //                            detail: 'Practice settings  are added successfully',
    //                            summary: 'Confirmation',
    //                            life: 5000,
    //                        })
    //                        // this.frmPracticeSettings.reset();
    //                    },
    //                    (err) => {
    //                        this.messageService.add({
    //                            key: 'alertToast',
    //                            severity: 'error',
    //                            detail: err.error,
    //                            summary: 'ERROR',
    //                            life: 7000,
    //                        })
    //                    },
    //                )
    //        } else {
    //            // alert("Update");
    //            console.log(this.frmPracticeSettings.value)

    //            this.configSettingService
    //                .configSettingUpdatepracticeSetting({
    //                    type: '1',
    //                    practiceId: this.practiceId,
    //                    body: this.frmPracticeSettings.value,
    //                })
    //                .subscribe(
    //                    (result) => {
    //                        console.log(result)

    //                        this.messageService.add({
    //                            key: 'alertToast',
    //                            severity: 'success',
    //                            detail: 'Practice settings  are added successfully',
    //                            summary: 'Confirmation',
    //                            life: 5000,
    //                        })
    //                        //this.frmPracticeSettings.reset();
    //                    },
    //                    (err) => {
    //                        this.messageService.add({
    //                            key: 'alertToast',
    //                            severity: 'error',
    //                            detail: err.error,
    //                            summary: 'ERROR',
    //                            life: 7000,
    //                        })
    //                    },
    //                )
    //        }
    //    }

    //    setTimeout(() => {
    //        this.isSaving = false;
    //    }, 3000);


    //}


    onSubmit(): void {
        if (this.isSaving) return;
        this.isSaving = true;

        if (this.frmPracticeSettings.invalid) {
            this.frmPracticeSettings.markAllAsTouched();
            console.log('Form Invalid', this.frmPracticeSettings.value);
            this.isSaving = false;
            return;
        }

        const formData = this.frmPracticeSettings.value;
        console.log('Form Submitted', formData);

        if (!this.checkBillingSettingNames()) {
            this.messageService.add({
                key: 'alertToast',
                severity: 'error',
                summary: 'ERROR',
                detail: 'Billing setting names or alias must be different: List1, List2, and List3',
                life: 7000,
            });

            setTimeout(() => {
                this.isSaving = false;
            }, 2000);
            return;
        }

        const action = this.isEdit
            ? this.configSettingService.configSettingUpdatepracticeSetting({
                type: '1',
                practiceId: this.practiceId,
                body: formData,
            })
            : this.configSettingService.configSettingSavePracticeSettings({
                type: '1',
                practiceId: this.practiceId,
                body: formData,
            });

        action.subscribe({
            next: (result) => {
                console.log(result);
                this.messageService.add({
                    key: 'alertToast',
                    severity: 'success',
                    summary: 'Confirmation',
                    detail: `Practice settings are ${this.isEdit ? 'updated' : 'added'} successfully`,
                    life: 5000,
                });
            },
            error: (err) => {
                this.messageService.add({
                    key: 'alertToast',
                    severity: 'error',
                    summary: 'ERROR',
                    detail: err.error,
                    life: 7000,
                });
            },
            complete: () => {
                setTimeout(() => {
                    this.isSaving = false;
                }, environment.setDelayTimeOut);
            },
        });
    }


    checkBillingSettingNames(): boolean {
        const inpatientLabelText =
            this.frmPracticeSettings.get('inpatientLabelText').value
        const outpatientLabelText = this.frmPracticeSettings.get('outpatientLabelText').value
        const officeLabelText = this.frmPracticeSettings.get('officeLabelText').value

        const labels = [
            inpatientLabelText,
            outpatientLabelText,
            officeLabelText,
        ].filter(
            (value) => value !== null && value !== undefined && value.trim() !== '',
        )

        if (new Set(labels).size === labels.length) {
            return true
        } else {
            console.error('The label texts must be different.')
            return false
        }
    }

    //checkBillingSettingNames(): boolean {
    //    const inpatientLabelText = this.frmPracticeSettings.get('inpatientLabelText').value;
    //    const outpatientLabelText = this.frmPracticeSettings.get('outpatientLabelText').value;
    //    const officeLabelText = this.frmPracticeSettings.get('officeLabelText').value;

    //    {
    //        if (inpatientLabelText !== outpatientLabelText && inpatientLabelText !== officeLabelText && outpatientLabelText !== officeLabelText) {
    //            return true;
    //        } else {

    //            console.error('The label texts must be different.');
    //            return false;
    //        }
    //    }

    //}

    onEdit() {
        // alert('EDIT')
        this.configSettingService
            .configSettingGetPracticeSettings({ type: '1', practiceId: '0002' })
            .subscribe((res) => {
                this.frmPracticeSettings.patchValue(res)
                this.isEdit = true
            })
    }

    private speak(text: string) {
        // alert(text);
        const utterance = new SpeechSynthesisUtterance(text)

        window.speechSynthesis.speak(utterance)
    }

    //#region ToolTip  Messages

    getContolTip(controlType: string) {
        this.speakText = ''

        switch (controlType.toUpperCase()) {

            //# Application Features::


            case 'ENABLEDOCUMENTDOWNLOADS': {
                this.speakText = `This setting allows users to download the patient documents.`;
                break;
            } case 'Input S3 Configuration': {
                this.speakText = `This setting allows users to enable inputs3 configuration.`;
                break;
            }
            case 'Output S3 Configuration': {
                this.speakText = `This setting allows users to enable output s3 configuration.`;
                break;
            }
            case 'SELECTPRACTICE': {
                this.speakText = 'Choose the desired practice  to work with.';
                break;
            }

            case 'PATIENTAPPOINTMENTS': {
                this.speakText = `This setting makes the Appointments module accessible from the main sidebar, also manage its role-based access under Manage Roles.`;
                break;
            }
            case 'PATIENTIMAGES': {
                this.speakText = `This setting makes the images associated with patients accessible from the patient sidebar, also manage its role-based access under Manage Roles.`;
                break;
            }
            case 'PATIENTDOCUMENTS': {
                this.speakText = `This setting makes the documents associated with patients accessible from the patient sidebar, also manage its role-based access under Manage Roles.`;
                break;
            }
            case 'EXPORTDOCUMENTS': {
                this.speakText = `This setting makes the export documents  accessible from the patient sidebar, also manage its role-based access under Manage Roles.`;
                break;
            }
            case 'PATIENTARCHIVE': {
                //  this.speakText = 'Enable to archive patient records for future reference under patient profile';

               // this.speakText = 'This setting is specific to CareFinity Live Archive instance. When enabled, users can view significant events and restore archived patient records back into the EHR system as needed.';

                this.speakText =`This setting is specific to CareFinity Live Archive instance. When enabled, users can view significant events and restore archived patient records back into the EHR system as needed from the main sidebar.`
                break;
            }
            case 'FINANCIALSUMMARY': {
                this.speakText = `This setting makes the financials  accessible from the patient sidebar, also manage its role-based access under Manage Roles.`;
                break;
            }
            case 'PATIENTRESTORE': {
                //  this.speakText = `Specific to Live archive site. Enable to restore previously archive patient records under that patient profile`;

                this.speakText = `Specific to Live Archive site. When enabled patient's archived chart information can be restored from patient sidebar,  also user can  manage its role-based access under Manage Roles..`;
                break;
            }
            case 'PATIENTNOTES': {
                this.speakText = 'This setting makes the patient notes  accessible from the patient sidebar';
                break;
            }
            case 'PATIENTBILLING': {
                this.speakText = 'Enable to configure billing settings.';
                break;
            }
            case 'ARCHIVEINSTANCE': {


               // this.speakText = `Specific to Live archive site. Enables  patient search functionality on the landing page and a post transaction feature under the Financials tab in the patient profile.`;

              //  this.speakText = `This setting is specific to CareFinity Archive instance. When enabled, the patient search becomes the default page. It allows clinical users to access archived clinical and financial records from the patient navigation bar.`;

                this.speakText = `This setting is specific to CareFinity Archive instance. When enabled, the patient search becomes the default page. Allows clinical users to access archived clinical and financial records from patient sidebar, also manage its role-based access under Manage Roles.`;

                break;
            }
            case 'SHOWSENSITIVEDATA': {
                this.speakText = 'Enable to display sensitive patient data for pervilaged users under patient profile';
                break;
            }
            case 'SHOWEXPORTCCDA': {
                this.speakText = `This setting makes Export CCDA option visible on Export Documents Screen, to allow users to export documents in a (Consolidated Clinical Document Architecture) format.`;
                break;
            }
            case 'SIGNIFICANTEVENTS': {
                // this.speakText = `Specific to Live archive site.Enable to see the patient's significant events in their medical history under Patient profile`;

                this.speakText = `Specific to Live Archive site. When enabled patient's significant medical events becomes accessible from patient sidebar, also manage its role-based access under Manage Roles.`;
                break;
            }
            case 'ISREMOVEEMPTYINPUTFROMNOTETEMPLATE': {
                this.speakText = 'Remove empty input from note`s template';
                break;
            }
            //# Documents & Images
            case 'OUTPUTFOLDERPATH': {
                this.speakText = 'Specify the folder location  for storing  output files.';
                break;
            }
            case 'CONVERTFOLDERPATH': {
                this.speakText = 'Specify the folder location  for storing  converted files.';
                break;
            }
            case 'DOCUMENTFOLDERPATH': {
                this.speakText = 'Specifies the folder path for storing or accessing patient documents.';
                break;
            }
            case 'IMAGEFOLDERPATH': {
                this.speakText = 'Specifies the folder path for storing or accessing patient images.';
                break;
            }
            case 'ICSIMAGEFOLDERPATH': {
                this.speakText = 'Specifies the folder path for storing or accessing ICS images';
                break;
            }

            case 'XSLTFOLDERPATH': {
                this.speakText = 'Specify the folder location  for  storing XSLT files used for transforming XML data.';
                break;
            }
            //----------

            case 'LEADCONVERTERAPPPATH': {
                this.speakText = 'Specify the folder location   for storing lead data conversion.';
                break;
            }

            case 'NOTESFOLDERPATH': {
                this.speakText = 'Specify the folder location  for storing notes related to patient.';
                break;
            }

            case 'EXPORTDOCUMENTFOLDERPATH': {
                this.speakText = 'Specify the folder location  where exported documents from Carefinity are saved.';
                break;
            }

            //----------

            case 'BROWSERPDFVIEWER': {
                this.speakText = 'Enable to view PDFs directly in the browser without downloading..';
                break;
            }

            case 'IMAGEFILESZIPPED': {
                this.speakText = 'Enable to compress image files into a zip format for easier downloading.';
                break;
            }

            case 'DISABLEEMBEDDEDFONTS': {
                this.speakText = 'Enable to prevent embedded fonts in documents for faster loading.';
                break;
            }

            //# Export Features::

            case 'PRINTDOCUMENTS': {
                this.speakText = 'Enable to print patient documents directly from the system, for external use';
                break;
            }
            case 'PRINTIMAGES': {
                this.speakText = 'Enable to print patient images directly from the system, forexternal use';
                break;
            }
            case 'PRINTEXPORTDOCS': {
                this.speakText = 'Enable to print exported patient documents';
                break;
            }
            case 'PRINTREPORTS': {
                this.speakText = 'Enable to print various patient-related reports';
                break;
            }
            case 'PRINTAPPOINTMENTS': {
                this.speakText = 'Enable to print appointment schedules and details';
                break;
            }
            case 'PRINTPATIENTSCREEN': {
                this.speakText = `This setting allows users to print the patient data.`;
                break;
            }

            //# General Settings::

            case 'DEFAULTAPPOINTMENTTYPE': {
                this.speakText = `Choose the appointment type that will be preselected by default  to display the corresponding appointments list after login.`;
                break;
            }
            case 'CHARTUNIT': {
                this.speakText = 'Specifies whether chart measurements are shown in English or Metric units.';
                break;
            }
            case 'SHOWPRACTICEMESSAGEPOPUP': {
                this.speakText = 'Enables or disables pop-up notifications for practice messages.';
                break;
            }

            //# Documents & Images::

            case 'BROWSERPDFVIEWER': {
                this.speakText = 'Enable to view PDFs directly in the browser without downloading. ';
                break;
            }
            case 'IMAGEFILESZIPPED': {
                this.speakText = 'Enable to compress image files into a zip format for easier downloading.';
                break;
            }
            case 'DISABLEEMBEDDEDFONTS': {
                this.speakText = 'Enable to prevent embedded fonts in documents for faster loading.';
                break;
            }

            case 'ISREMOVEEMPTYINPUTFROMNOTETEMPLATE': {
                this.speakText = 'Remove empty input from note`s template.';
                break;
            }
            //# RTF Settings::

            case 'RTFSETTINGS': {
                this.speakText = 'Configure settings for handling Rich Text Format (RTF) files. ';
                break;
            }
            case 'LEFTMARGIN': {
                this.speakText = 'Defines the space on the left side of the page. ';
                break;
            }
            case 'RIGHTMARGIN': {
                this.speakText = 'Defines the space on the right side of the page. ';
                break;
            }
            case 'TOPMARGIN': {
                this.speakText = ' Defines the space at the top of the page. ';
                break;
            }
            case 'BOTTOMMARGIN': {
                this.speakText = 'Defines the space at the bottom of the page.';
                break;
            }
            case 'ORIENTATION': {
                this.speakText = 'Select the page layout orientation for RTF document ( Portrait or Landscape ).';
                break;
            }

            //# Multiple RTF Settings::

            case 'FORCENEWLINEBEFOREHEADER': {
                this.speakText = 'Enable to insert a new line before the header in the documents.';
                break;
            }
            case 'FORCENEWLINEAFTERHEADER': {
                this.speakText = ' Enable to insert a new line after the header in the documents.';
                break;
            }
            case 'HEADERFORMATBOLD': {
                this.speakText = 'Enable to display headers in bold formatting.';
                break;
            }
            case 'HEADERFORMATUNDERLINE': {
                this.speakText = ' Enable to display headers with underline formatting.';
                break;
            }
            case 'HEADERFORMATFONTSIZE': {
                this.speakText = 'Set the font size for the header text in the document.';
                break;
            }
            case 'HEADERFORMATFONTNAME': {
                this.speakText = 'Set the font type for the header text.';
                break;
            }
            case 'HEADERFORMATFONTCOLOR': {
                this.speakText = 'Set  the font color for the header text.';
                break;
            }
            case 'HEADERBLANK': {
                this.speakText = 'Choose the header option as needed (AppendRTF to PreviousRTF or SkipRTF).';
                break;
            }
            case 'RTFFILENAME': {
                this.speakText = 'RTF File name that we pass to the proc to get the list of RTF records.';
                break;
            }

            //# Billing Settings::

            case 'BILLINGXML':
                {
                    this.speakText = 'Specifies the data  folder path for storing or accessing billing realted XML files.';
                    break;
                }
            case 'LIST1FILENAME':
                {
                    this.speakText = 'Provide the file name  for the first  XML file.';
                    break;
                }
            case 'ALIASFORLIST1':
                {
                    this.speakText = 'Provide a shorthand reference for the first XML file.';
                    break;
                }
            case 'LIST2FILENAME':
                {
                    this.speakText = 'Provide the file name  for the secound  XML file.';
                    break;
                }
            case 'ALIASFORLIST2':
                {
                    this.speakText = 'Provide a shorthand reference for the secound  XML file';
                    break;
                }
            case 'LIST3FILENAME':
                {
                    this.speakText = 'Provide the file name  for the third  XML file.';
                    break;
                }
            case 'ALIASFORLIST3':
                {
                    this.speakText = 'Provide the file name  for the third  XML file.';
                    break;
                }

            //#Document Header Settings::

            case 'DOCENABLEPATIENTHEADER': {
                this.speakText = ' Enable to include patient header information in documents.';
                break;
            }
            case 'DOCPATIENTNAME': {
                this.speakText = 'Enable to display the patient`s full name in the header.';
                break;
            }
            case 'DOCGENDER': {
                this.speakText = 'Enable to display the patient`s gender in the header.';
                break;
            }
            case 'DOCDOB': {
                this.speakText = 'Enable to display the patient`s date of birth in the header.';
                break;
            }
            case 'DOCMRN': {
                this.speakText = 'Enable to display the patient`s medical record number in the header.';
                break;
            }
            case 'DOCSSN': {
                this.speakText = 'Enable to display the patient`s social security number in the header.';
                break;
            }
            case 'VISITDATE': {
                this.speakText = 'Enable to display the date of the patient`s visit in the header.';
                break;
            }
            case 'DESCRIPTION': {
                this.speakText = 'Enable to display a description of the visit or service in the header. ';
                break;
            }
            case 'LOCATION': {
                this.speakText = 'Enable to display the location of the visit in the header. ';
                break;
            }

            //#Notes Header Settings::

            case 'NOTEENABLEPATIENTHEADER': {
                this.speakText = 'Enable to include notes header information in patient notes.';
                break;
            }
            case 'NOTEPATIENTNAME': {
                this.speakText = 'Enable to display the patient`s name in the notes section.';
                break;
            }
            case 'NOTEGENDER': {
                this.speakText = 'Enable to display the patient`s gender in the notes section.';
                break;
            }
            case 'NOTEDOB': {
                this.speakText = 'Enable to display the patient`s date of birth in the notes section.';
                break;
            }
            case 'NOTEMRN': {
                this.speakText = 'Enable to display the patient`s MRN in the notes section.';
                break;
            }
            case 'NOTESSN': {
                this.speakText = 'Enable to display the patient`s SSN in the notes section.';
                break;
            }

            //#Financial Financial Settings::
            case 'VIEWINSURANCECARD': {
                this.speakText = `Enable to make view insurance card option  visible on the patient's Financal tab. `;
                break;
            }

            case 'VIEWEOBIMAGE': {
                this.speakText = `Enable to make view EOB images option visible on the patient's Financal tab.`;
                break;
            }

            //# S3 Storeage Settings ::

            case 'INPUTS3ACCESSKEY': {
                this.speakText = 'Enter Access Key ID for Amazon S3.';
                break;
            }

            case 'INPUTS3SECRETKEY': {
                this.speakText = 'Enter secret access Key for Amazon S3.';
                break;
            }

            case 'INPUTAWSBUCKET': {
                this.speakText = 'Enter name of your Amazon S3 storage bucket..';
                break;
            }

            case 'INPUTS3REGION': {
                this.speakText = 'Enter the AWS data center location for your resources.';
                break;
            }

            // OUT PUT
            case 'OUTPUTS3ACCESSKEY': {
                this.speakText = 'Enter Access Key ID for Amazon S3.';
                break;
            }

            case 'OUTPUTS3SECRETKEY': {
                this.speakText = 'Enter secret access Key for Amazon S3.';
                break;
            }

            case 'OUTPUTAWSBUCKET': {
                this.speakText = 'Enter name of your Amazon S3 storage bucket.';
                break;
            }

            case 'OUTPUTS3REGION': {
                this.speakText = 'Enter the AWS data center location for your resources.';
                break;
            }

            case 'PATIENTDEFAULTPAGE': {

                this.speakText = 'Choose the patient page that will be preselected by default when viewing a patient record.';
                break;
            }

            case 'INPUTSTORETYPE': {

                this.speakText = 'Specify whether the documents are stored locally or on Input S3 storage.';
                break;
            }

            case 'INPUTSTORETYPEIMAGE': {

                this.speakText = 'Specify whether the Images are stored locally or on Input  S3 storage.';
                break;
            }

            case 'OUTPUTSTORETYPE': {

                this.speakText = 'Specify whether the output documents are created locally or on output S3 storage.';
                break;
            }

            case 'SHOWPATIENTDEMOGRAPHICS': {

                this.speakText = `Enable to update Patient Demographics.`;
                break;
            }


            case 'SHOWPATIENTPAYER': {

                this.speakText = `Enable to add  Patient Payor`;
                break;
            }

            case 'INPUTS3CONFIGURATION': {

                this.speakText = `Enabling Input S3 configuration.`;
                break;
            }

            case 'OUTPUTS3CONFIGURATION': {

                this.speakText = `Enabling Output S3 configuration`;
                break;
            }


            case 'NOTESSTORETYPE': {

                this.speakText = `Specify whether the Notes are created locally or on Input S3 storage.`;
                break;
            }

            case 'PATIENTIMAGEVIEW': {

                this.speakText = `Specify whether the Patient images are listed as thumbnail view or list view.`;
                break;
            }

            case 'SKIPHEADERIFRTFBLANK': {

                this.speakText = `Enable if you want to skip the header in RTF file.`;
                break;
            }
                
                

        }

        //  this.speak(this.speakText);
    }

    //#endregion



    fetchPracticeSettingsFromXmlFile() {
        this.configSettingService
            .configSettingGetPracticeSettingsFromXmlFile({ type: '1', practiceId: this.practice.value })
            .subscribe({
                next: (res) => {
                    if (res) {
                        this.isEdit = true;
                        this.frmPracticeSettings.patchValue(res);
                        this.showPracticeMessage = true;
                        this.isDisabled = false;

                    }
                    else {
                        this.isEdit = false;
                        this.frmPracticeSettings.patchValue(res);
                        this.showPracticeMessage = true;
                        this.isDisabled = false;

                    }
                },
                error: (err) => {
                    console.error('Error loading practice settings:', err);
                    // Replace this with your actual notification logic
                    this.messageService.add({
                        key: 'alertToast',
                        severity: 'error',
                        //detail: 'Failed to load practice settings. Please try again later..',
                        detail: err.error,
                        summary: 'ERROR',
                        life: 7000,
                    })
                }
            });

    }

    resetSettings() {

        this.showPracticeMessage = false;

        this.practices = this.userPracticeService.userPracticesGetAllPracticesOfUser()
        this.practice.setValue(localStorage.getItem('EmrPracticeId'))
        this.practice.valueChanges
            .pipe(
                startWith(localStorage.getItem('EmrPracticeId')),
                switchMap((practice) => {
                    this.practiceId = practice
                    return this.configSettingService.configSettingGetPracticeSettings({
                        type: '1',
                        practiceId: practice,
                    })
                }),
            )
            .subscribe((res) => {
                if (res) {
                    this.isEdit = true
                    this.frmPracticeSettings.patchValue(res)
                } else {
                    this.isEdit = false
                    this.frmPracticeSettings.patchValue(res)
                }
            })

        // Subscribe to value changes for specific controls to ensure numeric values
        this.addValueChangeSubscriptions()
    }

    resetPracticeMessage() {
        this.showPracticeMessage = false;
    }

    testConnection(type: string) {


        let body = {
            accessId: this.frmPracticeSettings.value.inputS3AccessKey,
            awsBucketName: this.frmPracticeSettings.value.inputAwsBucket,
            region: this.frmPracticeSettings.value.inputS3Region,
            secretKey: this.frmPracticeSettings.value.inputS3SecretKey,
            type: "Input"
        };
        if (type == "Output") {
            body = {


                accessId: this.frmPracticeSettings.value.outputS3AccessKey,
                awsBucketName: this.frmPracticeSettings.value.outputAwsBucket,
                region: this.frmPracticeSettings.value.outputS3Region,
                secretKey: this.frmPracticeSettings.value.outputS3SecretKey,
                type: "Output"
            }

        }


        this.documentService.documentIsS3ConnectionSuccessful({
            body: {
               ...body
            }

        }).subscribe(result => {

            if (result) {

                this.messageService.add({

                    key: 'alertToast',
                                                severity: 'success',
                    detail: "Connected Successfully",
                                                summary: 'Success',
                                                life: 5000



                })
            }
            else {

                this.messageService.add({

                    key: 'alertToast',
                    severity: 'error',
                    detail: "Connection Failed",
                    summary: 'ERROR',
                    life: 5000

                })
            }



        })

    }
}
